import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutAutoMatchList extends Layout {
    buttonAddProfile: Button;
    layoutheaderAutoMatchList: LayoutHeader;
    sourceEquipmentMatch: DataSource;
    tableAutoMatchList: Table;
}
